<!-- <footer>

    <div class="footer-box">
        <div class="container">
            <div class="row">
                <div class="col-md-12 col-sm-12 col-xs-12">
                    <div class="link-block">
                        <div class="link-left-block"  tabindex="0" [attr.aria-label]="support@cowin.gov.in"><span class="email-txt accessibility-plugin-ac">For Grievances &amp; Feedback :</span> <span class="email-link"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope email-icon" viewBox="0 0 16 16">
                            <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383-4.758 2.855L15 11.114v-5.73zm-.034 6.878L9.271 8.82 8 9.583 6.728 8.82l-5.694 3.44A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.739zM1 11.114l4.758-2.876L1 5.383v5.73z"/>
                          </svg> <a href="mailto:support@cowin.gov.in" class="accessibility-plugin-ac">support@cowin.gov.in</a></span> </div>
                       <div class="link-right-block">
                        <ul>
                            <li role="link" tabindex="0" [attr.aria-label]="Privacy Policy">
                                <a  [routerLink]="'/privacy-policy'" class="accessibility-plugin-ac">
                                Privacy Policy </a>
                            </li>
                            <li role="link" role="link" tabindex="0" [attr.aria-label]="Terms of Service">
                                <a  [routerLink]="'/terms-condition'" class="accessibility-plugin-ac">Terms of Service </a>
                            </li>

                        </ul>

                        <p class="copyright accessibility-plugin-ac" role="presentation" [attr.aria-label]="Copyright © 2021 COWIN. All Rights Reserved" tabindex="0">
                            Copyright © 2021 COWIN. All Rights Reserved
                          </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>

    </footer> -->

<footer>
  <div class="footerContainer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-6">
          <div class="row">
            <div class="col-6 col-md-4 mb-sm-3 mb-md-0 vaccinationServices">
              <h4 class="accessibility-plugin-ac">
                {{ "HEADER.Vaccination_Services" | translate }}
              </h4>
              <ul>
                <li
                  role="link"
                  tabindex="0"
                  [attr.aria-label]="'HEADER.Register_Members' | translate"
                >
                  <a
                    href="{{ urls.selfReg }}{{
                      currLang != 'en' ? '?lang=' + currLang : ''
                    }}"
                    target="_blank"
                    class="accessibility-plugin-ac"
                  >
                    {{ "HEADER.Register_Members" | translate }}</a
                  >
                </li>
                <li
                  role="link"
                  tabindex="0"
                  [attr.aria-label]="
                    'HEADER.Search_Vaccination_Centers' | translate
                  "
                >
                  <a
                    href="#Search-Vaccination-Center"
                    class="accessibility-plugin-ac"
                  >
                    {{ "HEADER.Search_Vaccination_Centers" | translate }}</a
                  >
                </li>
                <li
                  role="link"
                  tabindex="0"
                  [attr.aria-label]="
                    'HEADER.Book_Vaccination_Slots' | translate
                  "
                >
                  <a
                    href="{{ urls.selfReg }}{{
                      currLang != 'en' ? '?lang=' + currLang : ''
                    }}"
                    target="_blank"
                    class="accessibility-plugin-ac"
                    >{{ "HEADER.Book_Vaccination_Slots" | translate }}</a
                  >
                </li>
                <li
                  role="link"
                  tabindex="0"
                  [attr.aria-label]="'HEADER.Manage_Appointment' | translate"
                >
                  <a
                    href="{{ urls.selfReg }}{{
                      currLang != 'en' ? '?lang=' + currLang : ''
                    }}"
                    target="_blank"
                    class="accessibility-plugin-ac"
                  >
                    {{ "HEADER.Manage_Appointment" | translate }}</a
                  >
                </li>
                <li
                  role="link"
                  tabindex="0"
                  [attr.aria-label]="'HEADER.Download_Certificate' | translate"
                >
                  <a
                    href="{{ urls.certificate }}{{
                      currLang != 'en' ? '?lang=' + currLang : ''
                    }}"
                    target="_blank"
                    class="accessibility-plugin-ac"
                  >
                    {{ "HEADER.Download_Certificate" | translate }}</a
                  >
                </li>
              </ul>
            </div>
            <div class="col-6 col-md-4 vaccinationServices">
              <h4 class="accessibility-plugin-ac">
                {{ "HEADER.Platforms" | translate }}
              </h4>
              <ul>
                <!-- <li role="link" tabindex="0" [attr.aria-label]="'HEADER.Co-WIN_International' | translate">
                            <a href="{{urls.international}}"  target="_blank"
                            class="accessibility-plugin-ac dropdown-item">
                            {{'HEADER.Co-WIN_International' | translate}}
                        </a>
                        </li> -->
                <li
                  role="link"
                  tabindex="0"
                  [attr.aria-label]="'HEADER.Co-WIN_International' | translate"
                >
                  <a
                    href="{{ urls.international }}"
                    target="_blank"
                    class="accessibility-plugin-ac"
                  >
                    <!-- {{'HEADER.Co-WIN_International' | translate}} -->CoWIN
                    International</a
                  >
                </li>
                <li
                  role="link"
                  tabindex="0"
                  [attr.aria-label]="'HEADER.VACCINATOR' | translate"
                >
                  <a
                    href="{{ urls.webApp }}"
                    target="_blank"
                    class="accessibility-plugin-ac"
                  >
                    {{ "HEADER.VACCINATOR" | translate }}</a
                  >
                </li>
                <!-- <li role="link" tabindex="0" [attr.aria-label]="Partners">
                          <a href="#" class="accessibility-plugin-ac"> Partners</a>
                         </li> -->
                <li
                  role="link"
                  tabindex="0"
                  [attr.aria-label]="'HEADER.DEPARTMENT_LOGIN' | translate"
                >
                  <a
                    href="{{ urls.admin }}"
                    target="_blank"
                    class="accessibility-plugin-ac"
                    >{{ "HEADER.DEPARTMENT_LOGIN" | translate }}
                  </a>
                </li>
                <li
                  role="link"
                  tabindex="0"
                  [attr.aria-label]="'FOOTER.Verify_Certificates' | translate"
                >
                  <a
                    href="{{ urls.verifyCertificate }}"
                    target="_blank"
                    class="accessibility-plugin-ac"
                    >{{ "FOOTER.Verify_Certificates" | translate }}</a
                  >
                </li>
                <li
                  role="link"
                  tabindex="0"
                  [attr.aria-label]="
                    'HEADER.Vaccination_Statistics' | translate
                  "
                >
                  <a
                    href="{{ urls.dashboard }}{{
                      currLang != 'en' ? '?lang=' + currLang : ''
                    }}"
                    target="_blank"
                    class="accessibility-plugin-ac"
                    >{{ "HEADER.Vaccination_Statistics" | translate }}</a
                  >
                </li>
              </ul>
            </div>
            <div class="col-6 col-md-4 vaccinationServices">
              <h4 class="accessibility-plugin-ac">
                {{ "HEADER.Resources" | translate }}
              </h4>
              <ul>
                <!-- <li role="link" tabindex="0" [attr.aria-label]="Updates & Notification">
                         <a href="#"  class="accessibility-plugin-ac">    Updates & Notifications</a>
                     </li> -->
                <li
                  role="link"
                  tabindex="0"
                  [attr.aria-label]="'HEADER.DOS_AND_DONTS' | translate"
                >
                  <a
                    class="accessibility-plugin-ac user-manual-link"
                    href="https://prod-cdn.preprod.co-vin.in/assets/pdf/Dos_and_Donts_for_Citizens.pdf"
                    download
                    target="_blank"
                    title="{{ 'HOME.DOS_AND_DONTS' | translate }}"
                    >{{ "HOME.DOS_AND_DONTS" | translate }}
                  </a>
                </li>

                <li
                  role="link"
                  tabindex="0"
                  [attr.aria-label]="'HEADER.Overview' | translate"
                >
                  <a
                    class="user-manual-link accessibility-plugin-ac"
                    href="https://prod-cdn.preprod.co-vin.in/assets/pdf/CoWIN_Overview.pdf"
                    download
                    target="_blank"
                    >{{ "HEADER.Overview" | translate }}
                  </a>
                </li>
                <li
                  role="link"
                  tabindex="0"
                  [attr.aria-label]="'HEADER.API_GUIDELINES' | translate"
                >
                  <a
                    class="user-manual-link accessibility-plugin-ac"
                    href="https://prod-cdn.preprod.co-vin.in/assets/docx/CoWINAPIGuidelinesFinal.pdf"
                    download
                    target="_blank"
                    ><!--{{'HEADER.API_GUIDELINES' | translate}} -->API
                    Guidelines
                  </a>
                </li>
                <li
                  role="link"
                  tabindex="0"
                  [attr.aria-label]="'HEADER.OPEN_APIS' | translate"
                >
                  <a
                    class="user-manual-link accessibility-plugin-ac"
                    href="https://apisetu.gov.in/api/cowin"
                    download
                    target="_blank"
                    >{{ "HEADER.OPEN_APIS" | translate }}
                  </a>
                </li>

                <li
                  role="link"
                  tabindex="0"
                  [attr.aria-label]="'Grievance Guidelines' | translate"
                >
                  <a
                    class="user-manual-link accessibility-plugin-ac"
                    href="https://prod-cdn.preprod.co-vin.in/assets/pdf/Grievance_Guidelines.pdf"
                    download
                    target="_blank"
                  >
                    <!--{{'HEADER.Grievance_Guidelines' | translate}} -->Grievance
                    Guidelines
                  </a>
                </li>
              </ul>
            </div>

            <div class="col-6 d-md-none vaccinationServices supportList">
              <h4 class="accessibility-plugin-ac">
                {{ "HOME.Support" | translate }}
              </h4>
              <ul>
                <li
                  role="link"
                  tabindex="0"
                  [attr.aria-label]="
                    'HOME.FREQUENTLY_ASKED_QUESTIONS' | translate
                  "
                >
                  <a [routerLink]="'/faq'" class="accessibility-plugin-ac">{{
                    "HOME.FREQUENTLY_ASKED_QUESTIONS" | translate
                  }}</a>
                </li>
                <li
                  role="link"
                  tabindex="0"
                  [attr.aria-label]="
                    'HEADER.Certificate_Corrections' | translate
                  "
                >
                  <a
                    href="{{ urls.selfReg }}{{
                      currLang != 'en' ? '?lang=' + currLang : ''
                    }}"
                    target="_blank"
                    class="accessibility-plugin-ac"
                    >{{ "HEADER.Certificate_Corrections" | translate }}</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-6 contactusCol">
          <div class="row mb-2">
            <div
              class="d-none d-md-block col-md-4 col-lg-6 vaccinationServices supportList"
            >
              <h4 class="accessibility-plugin-ac">
                {{ "HOME.Support" | translate }}
              </h4>
              <ul>
                <li
                  role="link"
                  tabindex="0"
                  [attr.aria-label]="
                    'HOME.FREQUENTLY_ASKED_QUESTIONS' | translate
                  "
                >
                  <a [routerLink]="'/faq'" class="accessibility-plugin-ac">{{
                    "HOME.FREQUENTLY_ASKED_QUESTIONS" | translate
                  }}</a>
                </li>
                <li
                  role="link"
                  tabindex="0"
                  [attr.aria-label]="
                    'HEADER.Certificate_Corrections' | translate
                  "
                >
                  <a
                    href="{{ urls.selfReg }}{{
                      currLang != 'en' ? '?lang=' + currLang : ''
                    }}"
                    target="_blank"
                    class="accessibility-plugin-ac"
                    >{{ "HEADER.Certificate_Corrections" | translate }}</a
                  >
                </li>
                <!-- <li role="link" tabindex="0" [attr.aria-label]="'HEADER.Certificate_Not_Received' | translate">
                              <a href="{{urls.selfReg}}" target="_blank" class="accessibility-plugin-ac">{{'HEADER.Certificate_Not_Received' | translate}}</a>
                              </li> -->
                <!-- <li role="link" tabindex="0" [attr.aria-label]="'HEADER.Blocked_Accounts' | translate">
                                  <a href="{{urls.selfReg}}" target="_blank" class="accessibility-plugin-ac">{{'HEADER.Blocked_Accounts' | translate}}  </a>
                              </li> -->
                <!-- <li role="link" tabindex="0" >
                                  <a href="#"  class="accessibility-plugin-ac">Certificate Not Received</a>
                                  </li>
                                  <li role="link" tabindex="0" >
                                  <a href="#"  class="accessibility-plugin-ac">Blocked Accounts</a>
                                  </li> -->
                <!-- <li role="link" tabindex="0" [attr.aria-label]="'HEADER.Contactus' | translate">
                                  <a routerLink="/"  fragment="howcanweHelp" class="accessibility-plugin-ac">{{'HEADER.Contactus' | translate}}</a>
                              </li> -->
              </ul>
            </div>
            <div class="col-md-8 col-lg-6 p-lg-0 vaccinationServices">
              <h4 class="accessibility-plugin-ac">
                {{ "HEADER.Contactus" | translate }}
              </h4>
              <div class="row">
                <div class="col-12 helpline">
                  <p class="accessibility-plugin-ac helplineNumber">
                    {{ "HOME.HELPLINE" | translate }}:
                    <span>
                      +<a
                        href="tel:911123978046"
                        class="accessibility-plugin-ac"
                        >91-11-23978046</a
                      >
                      ({{ "HEADER.Toll free" | translate }} -
                      <a
                        href="tel:1075"
                        aria-label="1075"
                        class="accessibility-plugin-ac"
                        >1075</a
                      >
                      <ng-container *ngIf="currLang == 'ta'">
                        &nbsp;/&nbsp;<a
                          href="tel:104"
                          class="accessibility-plugin-ac"
                          >104</a
                        >
                      </ng-container>

                      )
                    </span>
                  </p>
                  <p class="accessibility-plugin-ac technicalNumber">
                    {{ "HOME.Technical_Helpline" | translate }}:
                    <span
                      ><a
                        href="tel:0120-4783222"
                        class="accessibility-plugin-ac"
                        >0120-4783222</a
                      ></span
                    >
                  </p>
                  <!-- <p class="accessibility-plugin-ac">Email id: <span><a href="mailto:support@cowin.gov.in" class="accessibility-plugin-ac">support@cowin.gov.in</a></span>
                                  </p> -->
                  <!-- <p>
                                      {{'HOME.Email_Id' | translate}}: <span><a href="mailto:support@cowin.gov.in" class="accessibility-plugin-ac">support@cowin.gov.in</a></span>
                                  </p> -->
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="row mt-4 p-2">
                          <ul class="contact_numbers">
                              <li>
                                  <span>Child :</span> 1098
                              </li>
                              <li>
                                  <span>Mental Health :</span> 08046110007
                              </li>
                              <li>
                                  <span>Senior Citizens :</span> 14567
                              </li>
                              <li>
                                  <span>NCW :</span> 7827170170
                              </li>
                          </ul>
                      </div> -->
          <!-- <div class="row mt-4 p-2 helplineContacts">
                          <div class="col-sm-3">
                              <h4 class="accessibility-plugin-ac">Child</h4>
                              <ul>
                                  <li>
                                      <span><a href="tel:1098" class="accessibility-plugin-ac">1098</a></span>
                                  </li>
                              </ul>
                          </div>
                          <div class="col-sm-3">
                              <h4 class="accessibility-plugin-ac">Mental Health</h4>
                              <ul>
                                  <li>
                                      <span><a href="tel:08046110007" class="accessibility-plugin-ac">08046110007</a></span>
                                  </li>
                              </ul>
                          </div>
                          <div class="col-sm-3">
                              <h4 class="accessibility-plugin-ac">Senior Citizens</h4>
                              <ul>
                                  <li>
                                      <span><a href="tel:14567" class="accessibility-plugin-ac">14567</a></span>
                                  </li>
                              </ul>
                          </div>
                          <div class="col-sm-3">
                              <h4 class="accessibility-plugin-ac">NCW</h4>
                              <ul>
                                  <li>
                                      <span><a href="tel:7827170170" class="accessibility-plugin-ac">7827170170</a></span>
                                  </li>
                              </ul>
                          </div>
                      </div> -->
          <div class="row mt-2 helplineContacts">
            <div class="col-12 col-sm-12 col-md-12 col-1g-12">
              <ul>
                <li>
                  <h4 class="accessibility-plugin-ac">Child</h4>
                  <span
                    ><a href="tel:1098" class="accessibility-plugin-ac"
                      >1098</a
                    ></span
                  >
                </li>
                <li>
                  <h4 class="accessibility-plugin-ac">Mental Health</h4>
                  <span
                    ><a href="tel:08046110007" class="accessibility-plugin-ac"
                      >08046110007</a
                    ></span
                  >
                </li>
                <li>
                  <h4 class="accessibility-plugin-ac">Senior Citizens</h4>
                  <span
                    ><a href="tel:14567" class="accessibility-plugin-ac"
                      >14567</a
                    ></span
                  >
                </li>
                <li>
                  <h4 class="accessibility-plugin-ac">NCW</h4>
                  <span
                    ><a href="tel:7827170170" class="accessibility-plugin-ac"
                      >7827170170</a
                    ></span
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="row mt-3 mb-3">
                      <div class="col-12 col-md-12">
                          <ul class="footerLogos text-center">
                              <li> <img src="../../../../../assets/images/national-health-authority.jpg"
                                      class="img-fluid nhaImg"></li>
                              <li> <img src="../../../assets/images/undp-logo-vertical.svg" class="img-fluid">
                              </li>
                          </ul>
                      </div>
                  </div> -->
    </div>
    <!--LandingPage Footer-->
    <div class="container-fluid miniFooter">
      <div class="container-fluid">
        <div class="row bottomFooter">
          <div class="col-12 col-sm-12 col-md-4 col-lg-4 copyrightCol">
            <p
              class="accessibility-plugin-ac"
              role="presentation"
              [attr.aria-label]="'HEADER.Copyright' | translate"
              tabindex="0"
            >
              {{ "FOOTER.COPYRIGHT" | translate }}
            </p>
          </div>
          <div class="col-12 col-sm-12 col-md-4 col-lg-4 logosCol">
            <ul class="footerLogos text-center">
              <li>
                <a href="https://nha.gov.in" target="_blank">
                  <img
                    src="../../../../../assets/images/national-health-authority.jpg"
                    class="img-fluid nhaImg"
                  />
                </a>
              </li>
              <li>
                <a href="https://www.undp.org" target="_blank">
                  <img
                    src="../../../assets/images/undp-logo-vertical.svg"
                    class="img-fluid"
                  />
                </a>
              </li>
            </ul>
          </div>
          <div
            class="col-12 col-sm-12 col-md-4 col-lg-4 bottomFooterCol ml-auto"
          >
            <div class="row">
              <div
                class="col-6 col-sm-6 col-md-6 col-lg-4 ml-auto bottomFooterLinks1"
              >
                <a
                  [routerLink]="'/terms-condition'"
                  class="accessibility-plugin-ac"
                  >{{ "FOOTER.TERMS" | translate }}
                </a>
              </div>
              <div class="col-6 col-sm-6 col-md-6 col-lg-4 bottomFooterLinks2">
                <a
                  [routerLink]="'/privacy-policy'"
                  class="accessibility-plugin-ac pl-3"
                >
                  {{ "FOOTER.PRIVACY" | translate }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--LandingPage Footer-->
  </div>
</footer>
<!-- 
  <div class="container">
      <div class="row bottomFooter mt-4 mb-5 mb-md-0">
          <div class="col-12 col-sm-12 col-md-12 col-lg-3 copyrightCol">
              <p class="accessibility-plugin-ac" role="presentation"
                  [attr.aria-label]="'HEADER.Copyright' | translate" tabindex="0">
                  {{'FOOTER.COPYRIGHT' | translate}}
              </p>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-6 bottomFooterCol ml-auto">
              <div class="row">
                  <div class="col-12 col-sm-12  col-md-12 col-lg-4 ml-auto bottomFooterLinks1">
                      <a [routerLink]="'/terms-condition'" class="accessibility-plugin-ac">{{'FOOTER.TERMS' |
                          translate}} </a>
                  </div>
                  <div class="col-12 col-sm-12  col-md-12 col-lg-4 bottomFooterLinks2">
                      <a [routerLink]="'/privacy-policy'" class="accessibility-plugin-ac">
                          {{'FOOTER.PRIVACY' | translate}} </a>
                  </div>
              </div>
  
          </div>
      </div>
  </div> -->
